import Axios from 'axios';
import {get} from 'lodash';
const _ = {get};

/**
 * Cookie value by name.
 * @param {string} name
 * @returns {string|null}
 */
function cookieValue(name) {
    try {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    } catch (error) {
        return null;
    }
}

/**
 * Login URL for this host. Local vue-cli uses the customer app on 8085.
 * @returns {string}
 */
export function loginRedirect() {
    const host = location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
        return 'http://localhost:8085/login?from=' + encodeURIComponent(location.origin + '/');
    }
    const subdomain = location.host.split('.')[0];
    const domain = location.host.split('.')[1];
    const beta = subdomain.indexOf('beta') > -1;
    const from = encodeURIComponent(location.origin + '/');
    return beta
        ? `https://beta.${domain}.com/login?from=${from}`
        : `https://app.${domain}.com/login?from=${from}`;
}

export class HTTPClient {
    constructor(){
        this.client = Axios;
        Axios.interceptors.response.use(function(response){
            return response;
        }, function(e){
            // redirect on 401
            if(e.response&&e.response.status==401){
                localStorage.setItem('airQualityAdminToken', '');
                const host = window.location && window.location.hostname;
                if (host !== 'localhost' && host !== '127.0.0.1') {
                    window.location.href = loginRedirect();
                }
            }
            return Promise.reject(e);
        });
        
        this.token = localStorage.getItem('airQualityAdminToken') || cookieValue('authToken');
        if(this.token){
            this.client.defaults.headers.common['Authorization'] = "Bearer " + this.token;
        }
        this.client.defaults.headers.common['Content-Type'] = 'application/json';
        this.client.defaults.withCredentials = true;
    }

     /**
     * @param {string} url
     * @param {object} params
     * @returns {import('axios').AxiosResponse}
     */

    async robustQuery(url, params){
        try {
            let tries = 2;
            while(tries <= 3){
                let res = await this.client.get(url, {params : params} );
                if([200, 302].indexOf(res.status) > -1){
                    return res.data;
                } else {
                    tries ++;
                }
            }
            if(tries >=3 ){
                throw new Error('Connection attempts exceeded');
            }
        } catch (e) {
            let msg = (_.get(e, 'response.data.errorMessage')) || (e.response&&e.response.statusText) || '';
            throw new Error(msg);
        }
    }

    async robustPost(url, data) {
        // Should we attempt tries for robust post
        try {
            let res = await this.client.post(url, data);
            return res.data;
        } catch (e) {
            let msg = (_.get(e, 'response.data.errorMessage')) || (e.response&&e.response.statusText) || '';
            throw new Error(msg);
        }
    }

    async robustDelete(url, data) {
        try {
            let res = await this.client.delete(url, data);
            return res.data;
        } catch (e) {
            let msg = (_.get(e, 'response.data.errorMessage')) || (e.response&&e.response.statusText) || '';
            throw new Error(msg);
        }
    }
}